import script from "./ViewPastCards.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewPastCards.vue?vue&type=script&setup=true&lang=js"

import "./ViewPastCards.vue?vue&type=style&index=0&id=b96298b2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b96298b2"]])

export default __exports__